var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.origen === 'base')?_c('a',{staticClass:"a-volver-al-servidor",attrs:{"href":"volver","title":"Deja de valer lo guardado acá y vuelve a valer lo que diga el servidor"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('volver')}}},[_c('i',{staticClass:"fas fa-undo"}),_vm._v(" Volver al del servidor\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }